import { render, staticRenderFns } from "./ep_col.vue?vue&type=template&id=1e50cef4&scoped=true"
import script from "./ep_col.vue?vue&type=script&lang=js"
export * from "./ep_col.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e50cef4",
  null
  
)

export default component.exports